import { InventoryAdjustReason } from '../../constants/inventory-adjust-reason.js';
const NOTE_REQUIRED_REASONS = [InventoryAdjustReason.OTHER];
/** Whether an add, scrap or count with this reason must carry a note; the server and every form ask the same question. */
export function isAdjustNoteRequired(reasonId) {
    return reasonId != null && reasonId !== '' && NOTE_REQUIRED_REASONS.includes(Number(reasonId));
}
//# sourceMappingURL=is-adjust-note-required.js.map